import React, { useState, useContext, useEffect } from 'react'
import { IntakeContext } from 'context/IntakeContext'
import {
  Box,
  Button,
  Grid,
  Typography,
  Checkbox,
  FormControlLabel,
  Tooltip,
  IconButton,
  Fade,
} from '@mui/material'
import HelpIcon from '@mui/icons-material/Help'

export function FinancialFamiliarity({ onNext, key }) {
  const { intakeState, updateIntakeStateAtKey } = useContext(IntakeContext)

  const [options, setOptions] = useState({
    stocks: intakeState?.riskAssessment?.financialFamiliarity?.stocks || false,
    bonds: intakeState?.riskAssessment?.financialFamiliarity?.bonds || false,
    checking:
      intakeState?.riskAssessment?.financialFamiliarity?.checking || false,
    lifeInsurance:
      intakeState?.riskAssessment?.financialFamiliarity?.lifeInsurance || false,
    annuities:
      intakeState?.riskAssessment?.financialFamiliarity?.annuities || false,
    pensions:
      intakeState?.riskAssessment?.financialFamiliarity?.pensions || false,
    tsp: intakeState?.riskAssessment?.financialFamiliarity?.tsp || false,
    cd: intakeState?.riskAssessment?.financialFamiliarity?.cd || false,
  })

  const toggle = (field) => {
    const financialFamiliarity = { ...options, [field]: !options[field] }
    setOptions(financialFamiliarity)

    updateIntakeStateAtKey({
      riskAssessment: {
        ...intakeState?.riskAssessment,
        financialFamiliarity: { ...financialFamiliarity },
      },
    })
  }

  const handleContinue = () => {
    if (onNext) onNext()
  }

  return (
    <Grid key={key} item xs={12} mb={3}>
      <Box sx={{ textAlign: 'left' }}>
        <Typography
          variant="headerTitle"
          sx={{ color: '#262627', fontSize: { xs: '24px', sm: '30px' } }}
        >
          Which of the following are you familiar with?
          <Tooltip
            TransitionComponent={Fade}
            title="As in, I would be confident that I could explain what this is to another person."
            placement="top"
            color="info"
            enterTouchDelay={0}
            leaveTouchDelay={3000}
          >
            <IconButton size="small" color="dark">
              <HelpIcon sx={{ marginTop: '-6px' }} />
            </IconButton>
          </Tooltip>
        </Typography>
      </Box>
      <Box
        mt={3}
        display="grid"
        gridTemplateColumns={{ xs: '1fr', sm: '1fr 1fr' }}
        gap={2}
        marginLeft={3}
      >
        <FormControlLabel
          labelPlacement="end"
          sx={{
            alignItems: 'center',
            '& .MuiFormControlLabel-label': {
              fontSize: 18,
              color: '#495057',
              fontWeight: 400,
            },
          }}
          control={
            <Checkbox
              checked={options.stocks}
              onChange={() => toggle('stocks')}
            />
          }
          label={'Stocks'}
        />
        <FormControlLabel
          labelPlacement="end"
          sx={{
            alignItems: 'center',
            '& .MuiFormControlLabel-label': {
              fontSize: 18,
              color: '#495057',
              fontWeight: 400,
            },
          }}
          control={
            <Checkbox
              checked={options.bonds}
              onChange={() => toggle('bonds')}
            />
          }
          label={'Bonds'}
        />
        <FormControlLabel
          labelPlacement="end"
          sx={{
            alignItems: 'center',
            '& .MuiFormControlLabel-label': {
              fontSize: 18,
              color: '#495057',
              fontWeight: 400,
            },
          }}
          control={
            <Checkbox
              checked={options.checking}
              onChange={() => toggle('checking')}
            />
          }
          label={'Checking Accounts'}
        />
        <FormControlLabel
          labelPlacement="end"
          sx={{
            alignItems: 'center',
            '& .MuiFormControlLabel-label': {
              fontSize: 18,
              color: '#495057',
              fontWeight: 400,
            },
          }}
          control={
            <Checkbox
              checked={options.lifeInsurance}
              onChange={() => toggle('lifeInsurance')}
            />
          }
          label={'Life Insurance'}
        />
        <FormControlLabel
          labelPlacement="end"
          sx={{
            alignItems: 'center',
            '& .MuiFormControlLabel-label': {
              fontSize: 18,
              color: '#495057',
              fontWeight: 400,
            },
          }}
          control={
            <Checkbox
              checked={options.annuities}
              onChange={() => toggle('annuities')}
            />
          }
          label={'Annuities'}
        />
        <FormControlLabel
          labelPlacement="end"
          sx={{
            alignItems: 'center',
            '& .MuiFormControlLabel-label': {
              fontSize: 18,
              color: '#495057',
              fontWeight: 400,
            },
          }}
          control={
            <Checkbox
              checked={options.pensions}
              onChange={() => toggle('pensions')}
            />
          }
          label={'Pensions'}
        />
        <FormControlLabel
          labelPlacement="end"
          sx={{
            alignItems: 'center',
            '& .MuiFormControlLabel-label': {
              fontSize: 18,
              color: '#495057',
              fontWeight: 400,
            },
          }}
          control={
            <Checkbox checked={options.tsp} onChange={() => toggle('tsp')} />
          }
          label={'Thrift Savings Plan (TSP)'}
        />
        <FormControlLabel
          labelPlacement="end"
          sx={{
            alignItems: 'center',
            '& .MuiFormControlLabel-label': {
              fontSize: 18,
              color: '#495057',
              fontWeight: 400,
            },
          }}
          control={
            <Checkbox checked={options.cd} onChange={() => toggle('cd')} />
          }
          label={'Certificate of Deposit (CD)'}
        />
      </Box>

      <Box mt={3} display="flex" gap={2} justifyContent="flex-end">
        <Button 
          variant="parcoRounded" 
          onClick={handleContinue} 
        >
          Next
        </Button>
      </Box>
    </Grid>
  )
}

export default FinancialFamiliarity
